// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { gql, graphql } from 'react-apollo';
import uniqBy from 'lodash/uniqBy';

import PlatformsPage from '~/components/content/containers/PlatformsPage';
import UIStore from '~/stores/ui-store';
import type { Company as CompanyType } from '~/types';

const PlatformsPageWithData = graphql(
    gql`
        query(
            $text: String,
            $maker: String
        ) {
            platforms(text: $text, maker: $maker) {
                id,
                name,
                slug,
                content {
                    brief {
                        md
                    }
                }
                image {
                    secure_url
                },
                reviews {
                    id,
                    state
                }
            },
            makers: platforms {
                maker {
                    id,
                    name
                }
            }
        }
        `,
    {
        options: props => ({
            variables: props.query,
        }),
        props: ({ data: { platforms, makers, loading }, ownProps }) => {
            const uniqMakers =
                makers &&
                uniqBy(
                    makers.map(m => m.maker).filter(m => !!m && m.id),
                    m => m && m.id
                );

            UIStore.setIsLoading(loading);

            return {
                platforms,
                makers: uniqMakers,
                maker: ownProps.query.maker,
                ...ownProps,
            };
        },
    }
)(PlatformsPage);

@observer
export default class PlatformsPageContainer extends React.Component {
    @observable text: string;
    @observable maker: CompanyType;
    @computed get query(): Object {
        return {
            text: this.text,
            maker: this.maker && this.maker.id,
        };
    }
    handleInputChange: Function;
    handleMakerChange: Function;

    constructor() {
        super();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMakerChange = this.handleMakerChange.bind(this);
    }

    @action handleInputChange(value: string) {
        this.text = value;
    }

    @action handleMakerChange(maker: CompanyType) {
        this.maker = maker || undefined;
    }

    render() {
        return (
            <PlatformsPageWithData
                onInputChange={ this.handleInputChange }
                onMakerChange={ this.handleMakerChange }
                query={ this.query }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/containers/PlatformsPageContainer.js